// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  type: 'dev',
  production: false,

  FRAME_MIN_SPAN: 200,
  FRAME_MAX_SPAN: 1500,
  FRAME_OVERFLOW_SPACE: 300,

  DEFAULT_PRODUCT_CODE: '23059',

  lamellaSpan: 26.5,
  lamellaMaxSpace: 265,

  installationDirections: ['BOTH', 'HORIZONTAL', 'VERTICAL'],
  productTypes: ['default','lamella' ], //TODO: create service
  lamellaFamilies: ["Oslo", "Stockholm", "Copenhagen", "Helsinki", "Tallinn" ],
  lamellaMaterials: ['Powder coated', 'anodized'],

  // spring hierarchy implements tree structure
  roles:  new Map([
    ['ROLE_ADMIN', [
        'ROLE_EMPLOYEE_ADMIN'
    ]],
    ['ROLE_EMPLOYEE_ADMIN', [
        'ROLE_EMPLOYEE'
    ]],
    ['ROLE_EMPLOYEE', [
        'ROLE_CUSTOMER_ADMIN'
    ]],
    ['ROLE_CUSTOMER_ADMIN', [
        'ROLE_CUSTOMER'
    ]],
    ['ROLE_CUSTOMER', [
        'ROLE_USER'
    ]]
  ])
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
